/******************************* 产教融合 - 校企合作 管理端接口 *******************************/

import request from '@/utils/request';
/******************************* 岗位审核  *******************************/
// 获取企业信息
export function enterpriseInfo() {
  return request({
    url: `/cjrh/xqhzQyrz/employeeInfo`,
    method: 'post'
  });
}

/******************************* 企业审核  *******************************/
// 列表
export function enterpriseAuditList(data) {
  return request({
    url: `/cjrh/xqhzQyrz/list`,
    method: 'post',
    data
  });
}
// 详情
export function enterpriseAuditDetails(params) {
  return request({
    url: `/cjrh/xqhzQyrz/details`,
    method: 'get',
    params
  });
}
// 审核
export function enterpriseAuditEdit(data) {
  return request({
    url: `/cjrh/xqhzQyrz/updateShzt`,
    method: 'post',
    data
  });
}
/******************************* 项目审核  *******************************/

// 列表
export function projectAuditList(data) {
  return request({
    url: `/cjrh/xqhzXqxm/GlXqxmlist`,
    method: 'post',
    data
  });
}
// 详情
export function projectAuditDetails(params) {
  return request({
    url: `/cjrh/xqhzXqxm/details`,
    method: 'get',
    params
  });
}

// 审核
export function projectAuditEdit(data) {
  return request({
    url: `/cjrh/xqhzXqxm/updateShzt`,
    method: 'post',
    data
  });
}

/******************************* 岗位审核  *******************************/
// 列表
export function postAuditList(data) {
  return request({
    url: `/cjrh/xqhzRczpZpgw/QyZpgwList`,
    method: 'post',
    data
  });
}
// 详情
export function postAuditDetails(params) {
  return request({
    url: `/cjrh/xqhzRczpZpgw/details`,
    method: 'get',
    params
  });
}

// 审核
export function postAuditEdit(data) {
  return request({
    url: `/cjrh/xqhzRczpZpgw/updateShzt`,
    method: 'post',
    data
  });
}

/******************************* 问答-需求类型管理  *******************************/
// 列表
export function demandTypeList(data) {
  return request({
    url: `/cjrh/xqhzXqlx/selectAllList`,
    method: 'post',
    data
  });
}

// 删除
export function demandTypeDel(data) {
  return request({
    url: `/cjrh/xqhzXqlx/delete`,
    method: 'post',
    data
  });
}

// 新增
export function demandTypeAdd(data) {
  return request({
    url: `/cjrh/xqhzXqlx/add`,
    method: 'post',
    data
  });
}

// 编辑
export function demandTypeEdit(data) {
  return request({
    url: `/cjrh/xqhzXqlx/edit`,
    method: 'post',
    data
  });
}

// 详情
export function demandTypeDetail(id) {
  return request({
    url: `/cjrh/xqhzXqlx/details/${id}`,
    method: 'get',
  });
}

// 需求类型下拉
export function getDemandTypeDown(data) {
  return request({
    url: `/cjrh/xqhzXqlx/selectXlList`,
    method: 'post',
    data
  });
}

// 回答部门下拉
export function getCollegeDown(data) {
  return request({
    url: `/cjrh/xqhzXqlx/selectzdbmlist`,
    method: 'post',
    data
  });
}

/******************************* 问答-需求回复  *******************************/
// 列表
export function demandReplyList(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/selectXqhf`,
    method: 'post',
    data
  });
}

// 删除
export function demandReplyDel(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/delete`,
    method: 'post',
    data
  });
}

// 撤销
export function demandReplyBack(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/cx`,
    method: 'post',
    data
  });
}

// 详情
export function demandReplyDetail(id) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/details/${id}`,
    method: 'get',
  });
}

// 答复
export function demandReplyEdit(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/editgl`,
    method: 'post',
    data
  });
}

// 转交
export function demandReplyTo(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/glzj`,
    method: 'post',
    data
  });
}

/******************************* 企业管理  *******************************/
// 列表
export function companyManageList(data) {
  return request({
    url: `/cjrh/xqhzQyrz/qyList`,
    method: 'post',
    data
  });
}

// 更改企业状态
export function companyManageLock(data) {
  return request({
    url: `/cjrh/xqhzQyrz/updateJyzt`,
    method: 'post',
    data
  });
}

/******************************* 入驻统计  *******************************/
export function topCompanyCount(data) {
  return request({
    url: `/cjrh/xqhzQyrz/rztj`,
    method: 'post',
    data
  });
}


export function topNeedCount(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/xqzs`,
    method: 'post',
    data
  });
}

// 需求统计
export function needCount(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/xqtj`,
    method: 'post',
    data
  });
}

// 应答统计
export function replyCount(data) {
  return request({
    url: `/cjrh/xqhzQyrzXqlx/ydtj`,
    method: 'post',
    data
  });
}

/******************************* 管理-学院简介管理  *******************************/
// 列表
export function getIntroduceList(data) {
  return request({
    url: `/cjrh/xqhzXyjj/list`,
    method: 'post',
    data
  });
}

// 学院下拉列表
export function getCollegeDownList(data) {
  return request({
    url: `/cjrh/xqhzXyjj/xylist`,
    method: 'post',
    data
  });
}

// 删除
export function delIntroduce(data) {
  return request({
    url: `/cjrh/xqhzXyjj/delete`,
    method: 'post',
    data
  });
}

// 详情
export function getIntroduceDetail(params) {
  return request({
    url: `/cjrh/xqhzXyjj/details`,
    method: 'get',
    params
  });
}

// 编辑
export function editIntroduce(data) {
  return request({
    url: `/cjrh/xqhzXyjj/edit`,
    method: 'post',
    data
  });
}

// 新建
export function addIntroduce(data) {
  return request({
    url: `/cjrh/xqhzXyjj/add`,
    method: 'post',
    data
  });
}
